import { useMutation } from "@apollo/client";

import { ProtocolEditRoute_VisitDeleteDocument } from "../mutations.generated";
import { PROTOCOL_GET_BY_ID } from "./useProtocolEditRoute_GetById";

export default function useProtocolVisitDelete(protocolId: string) {
    const [deleteVisit, { loading, error }] = useMutation(ProtocolEditRoute_VisitDeleteDocument, {
        refetchQueries: [{ query: PROTOCOL_GET_BY_ID, variables: { protocolId } }],
    });

    return {
        deleteVisit: (visitId: string) =>
            deleteVisit({
                variables: {
                    input: { protocolVisitId: visitId },
                },
            }),
        loading,
        error,
    };
}
